export interface StatusGroup {
  name: string;
  color: string;
  bg: string;
  border: string;
  isReturn: boolean;
  isKontant?: boolean;
  isDirekte?: boolean;
  isPlukk?: boolean;
  isBkCode?: boolean;
    statuses: string[] | null; // null = special logic (Alle ordre / Retur / Kontant / Direkte ordre / Plukkordre / Ordre med BK kode)
}

/** orderPaymentMethod values that count as "Kontant". */
export const KONTANT_PAYMENT_METHODS = ['7', '07', '49'];

/** directOrderFlag (O-DIRREG) values that count as "Direkte ordre". */
export const DIREKTE_ORDER_TYPES = ['J'];

/** An order counts as "Plukkordre" when O-SKAFF='P'. */
export const isPlukkOrdre = (skaff: string) => skaff === 'P';

/** An order counts as "Ordre med BK kode" when O-BK is set to any code (non-blank) — except
 *  'K', which every kontantordre carries and would otherwise make this box redundant with
 *  "Kontant" instead of highlighting orders with a genuinely notable BK code. */
export const hasBkCode = (bk: string) => bk.trim() !== '' && bk.trim() !== 'K';

export const STATUS_GROUPS: StatusGroup[] = [
  {
    name: 'Alle ordre',
    color: '#1976d2',
    bg: '#e3f2fd',
    border: '#1976d2',
    isReturn: false,
    statuses: null,
  },
  {
    name: 'Ferdigmeldt',
    color: '#2e7d32',
    bg: '#e8f5e9',
    border: '#2e7d32',
    isReturn: false,
    statuses: ['Ferdigmeldt', 'Fmeld./KS-oppgjør', 'Lagerovf. (f.meldt)', 'Verkstedsord. (f.meldt)', 'Fakturert', 'Forhånds ordre', 'Påbegynt samleordre'],
  },
  {
    name: 'Venteordre',
    color: '#f9a825',
    bg: '#fffde7',
    border: '#f9a825',
    isReturn: false,
    statuses: ['Venter godkjenning', 'Sluppet forhåndsordre'],
  },
  {
    name: 'Printet',
    color: '#7b1fa2',
    bg: '#f3e5f5',
    border: '#7b1fa2',
    isReturn: false,
    statuses: ['Printet', 'Pakket', 'Ferdig plukket'],
  },
  {
    name: 'Registrert',
    color: '#1976d2',
    bg: '#e3f2fd',
    border: '#1976d2',
    isReturn: false,
    statuses: ['Ferdig registrert'],
  },
  {
    name: 'Ikke fullført',
    color: '#d32f2f',
    bg: '#fdecea',
    border: '#d32f2f',
    isReturn: false,
    statuses: ['Påbegynt, ikke fullført', 'Kred-stopp, ikke print', 'Ufullstendig'],
  },
  {
    name: 'Utgårmeldt',
    color: '#757575',
    bg: '#f5f5f5',
    border: '#9e9e9e',
    isReturn: false,
    statuses: ['Utgårmeldt', 'Korr. etter f.melding', 'Restreg. (f.meldt)', 'Retur til lev.', 'Delferdigmeldt'],
  },
  {
    name: 'Kontant',
    color: '#00695c',
    bg: '#e0f2f1',
    border: '#00695c',
    isReturn: false,
    isKontant: true,
    statuses: null,
  },
  {
    name: 'Direkte ordre',
    color: '#e65100',
    bg: '#fff3e0',
    border: '#e65100',
    isReturn: false,
    isDirekte: true,
    statuses: null,
  },
  {
    name: 'Plukkordre',
    color: '#6a1b9a',
    bg: '#f3e5f5',
    border: '#6a1b9a',
    isReturn: false,
    isPlukk: true,
    statuses: null,
  },
  {
      name: 'Ordre med BK kode',
    color: '#ad1457',
    bg: '#fce4ec',
    border: '#ad1457',
    isReturn: false,
    isBkCode: true,
    statuses: null,
  },
  {
    name: 'Retur',
    color: '#d32f2f',
    bg: '#fff5f5',
    border: '#d32f2f',
    isReturn: true,
    statuses: null,
  },
];

/** All backend status strings that belong to a given group name. */
export function getGroupStatuses(groupName: string): string[] | null {
  return STATUS_GROUPS.find(g => g.name === groupName)?.statuses ?? null;
}
